<div class="access-locked">
  <h1 class="modal-title"><span class="flaticon solid exclamation-point-2"></span> Additional access is required</h1>
  <div>
    <p>
      This activity requires additional access.
      <a href="/account/members/request-access?url={{requested_url}}">Ask the Papertrail account administrators</a>
      for additional access to perform this activity, or
      <a href="http://help.papertrailapp.com">learn more about Papertrail permissions</a>.
    </p>
    <p>{{custom_message}}</p>
  </div>
</div>